export default {
  apiUrl: "/api/addresses",
  dataPath: "result.rows",
  paginationPath: "data",
  trackBy: "id",
  detailRowComponentName: "offline-store-manage-editor",
  onEachSide: 1,
  preloadList: [],
  sortOrder: [
    {
      field: "id",
      sortField: "id",
      direction: "DESC"
    }
  ],
  paginationTemplate: {
    class: "",
    template: "총 {total}개 중의 {from} 부터 {to}"
  },
  fields: [
    // {
    //   name: "__checkbox",
    //   titleClass: "text-center",
    //   dataClass: "text-center"
    // },
    {
      name: "__slot:actions",
      title: "편집 삭제",
      titleClass: "center aligned",
      dataClass: "center aligned"
    },
    {
      name: "id",
      title: '<p style="white-space: nowrap"> 아이디 </p>',
      sortField: "id",
      titleClass: "text-center",
      dataClass: "text-right"
    },
    {
      name: "name",
      title: '<i style="white-space: nowrap">이름</i>',
      sortField: "name",
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "subStringField"
    },
    {
      name: "address",
      title: '<i style="white-space: nowrap">주소</i>',
      sortField: "address",
      titleClass: "text-center",
      dataClass: "text-center",
      callback: "subStringField"
    },
    {
      name: "is_shut_down",
      title: '<i style="white-space: nowrap">폐점</i>',
      sortField: "is_shut_down",
      titleClass: "text-center",
      dataClass: "text-center",
      callback: "boolFieldShowIfTrue"
    },
    // {
    //   name: "is_new",
    //   title: '<i style="white-space: nowrap">신규</i>',
    //   sortField: "is_new",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "boolFieldShowIfTrue"
    // },
    // {
    //   name: "country",
    //   title: '<i style="white-space: nowrap">나라</i>',
    //   sortField: "country",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "city",
    //   title: '<i style="white-space: nowrap">도/광역시</i>',
    //   sortField: "city",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "administrative",
    //   title: '<i style="white-space: nowrap">시/구</i>',
    //   sortField: "administrative",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "locality",
    //   title: '<i style="white-space: nowrap">소재지</i>',
    //   sortField: "locality",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "street",
    //   title: '<i style="white-space: nowrap">도로명 주소</i>',
    //   sortField: "street",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "locality_detail",
    //   title: '<i style="white-space: nowrap">상세 소재지</i>',
    //   sortField: "locality_detail",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "street_detail",
    //   title: '<i style="white-space: nowrap">상세 도로명 주소</i>',
    //   sortField: "street_detail",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    {
      name: "latitude",
      title: '<i style="white-space: nowrap">위도</i>',
      sortField: "latitude",
      titleClass: "text-center",
      dataClass: "text-right"
      // callback: "subStringField"
    },
    {
      name: "longitude",
      title: '<i style="white-space: nowrap">경도</i>',
      sortField: "longitude",
      titleClass: "text-center",
      dataClass: "text-right"
      // callback: "subStringField"
    },
    {
      name: "bizloc_code",
      title: '<i style="white-space: nowrap">점포 코드</i>',
      sortField: "bizloc_code",
      titleClass: "text-center",
      dataClass: "text-right"
      // callback: "subStringField"
    },
    // {
    //   name: "address_ovr",
    //   title: '<p style="white-space: nowrap">덮어쓸 주소</p>',
    //   sortField: "address_ovr",
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "subStringField"
    // },
    // {
    //   name: "how_to_go",
    //   title: '<p style="white-space: nowrap">가는 길</p>',
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "textField"
    // },
    // {
    //   name: "img_place",
    //   title: '<p style="white-space: nowrap">장소 이미지</p>',
    //   titleClass: "text-center",
    //   dataClass: "text-right",
    //   callback: "imgField"
    // },
    {
      name: "type",
      title: '<p style="white-space: nowrap">타입</p>',
      sortField: "type",
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "subStringField"
    },
    {
      name: "is_enabled",
      title: '<p style="white-space: nowrap">발행</p>',
      sortField: "is_enabled",
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "toggleField"
    },
    {
      name: "warehouse_name",
      title: '<i style="white-space: nowrap">집화지</i>',
      sortField: "warehouse_name",
      titleClass: "text-center",
      dataClass: "text-right"
    },
    {
      name: "delivery_delay_hours",
      title: '<i style="white-space: nowrap">배송 지연 시간</i>',
      sortField: "delivery_delay_hours",
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "subStringField"
    }
    // {
    //   name: "__slot:actions",
    //   title: "편집 삭제",
    //   titleClass: "center aligned",
    //   dataClass: "center aligned"
    // }
  ]
};



// WEBPACK FOOTER //
// ./src/spa/components/board/address/Config.js